import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { ProfileService } from 'src/app/services/profile.service';
import { TriggerService } from 'src/app/services/trigger.service';
import { environment } from 'src/environments/environment';
import { Profile } from 'src/app/models/profile.model';

@Component({
  standalone: false,
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  active: boolean = false;
  private destroy$ = new Subject<void>();
  profileData: Profile | null = null;
  private profileSubscription!: Subscription;

  private lastScreenWidth: number = window.innerWidth;

  constructor(
    public baseService: BaseService,
    private profileService: ProfileService,
    private triggerService: TriggerService,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.active = window.innerWidth > 1024;
    this.lastScreenWidth = window.innerWidth;

    this.profileSubscription = this.profileService.profileData$.subscribe((data) => {
      if (data) {
        this.profileData = data;
      }
      // this.initLiveChat();
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkScreenWidth();
  }

  private checkScreenWidth(): void {
    const currentWidth = window.innerWidth;
    if (currentWidth > 1024 && this.lastScreenWidth <= 1024) {
      this.active = true;
    }
    if (currentWidth <= 1024 && this.lastScreenWidth > 1024) {
      this.active = false;
    }
    this.lastScreenWidth = currentWidth;
  }

  collapseToogle(e: boolean): void {
    this.active = e;
    this.triggerService.triggerSidebar$.next();
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: EventTarget | null): void {
    if (!target) return;
    if ((target as HTMLElement).className === 'layer') {
      this.active = false;
    }
  }

  private initLiveChat() {
    const script = this.renderer.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    (window as any).$crisp = [];
    (window as any).CRISP_WEBSITE_ID = environment.CRISP_WEBSITE_ID;
    (window as any).CRISP_TOKEN_ID = this.profileData?.email;
    (window as any).CRISP_RUNTIME_CONFIG = {
      session_merge: true,
    };
    script.type = 'text/javascript';
    script.async = true;
    this.renderer.appendChild(document.head, script);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
